import React, { useState } from "react";
import "./login.css";
import localImages from "../../Constant/localImages";
import { InputField, Submitbtn } from "../../Component";
import { jwtDecode } from "jwt-decode";
import { login, set } from "../../store/slices/homeSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import { useNavigate } from "react-router-dom";
import { showSnackbar, hideSnackbar } from "../../store/slices/snackbarSlice";
function Login() {
  const dispatch: Function = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      username: userName,
      password: password,
    };
    dispatch(
      login({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            if (res?.data?.token) {
              var decoded: any = jwtDecode(res.data?.token.access.token);
              if (decoded) {
                localStorage.setItem("user", JSON.stringify(decoded));
                dispatch(set({ Name: decoded?.name }));
                dispatch(set({ role: decoded?.role }));
                dispatch(set({ loginType: decoded?.loginType }));
                if (decoded.role === "SUPERADMIN") {
                  navigate("Superadmin");
                } else if (decoded.role === "ADMIN") {
                  navigate("admin");
                } else if (decoded.role === "CXO") {
                  navigate("cxo");
                } else if (decoded.role === "PUBLICATION") {
                  navigate("publication");
                }
              };
            };
            dispatch(showSnackbar({ message: res.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const curouselData = [
    {
      imgPath: localImages?.loginSlide1,
      text: "First slide label",
      subText: "Some representative placeholder content for the first slide.",
    },
    {
      imgPath: localImages?.loginSlide2,
      text: "Second slide label",
      subText: "Some representative placeholder content for the first slide.",
    },
    {
      imgPath: localImages?.loginSlide3,
      text: "Third slide label",
      subText: "Some representative placeholder content for the first slide.",
    },
  ];
  return (
    <div className="row mx-0 AuthDiv align-items-center">
      <div className="logoDiv">
        <img src={localImages?.logo} alt="logo" className="logo" />
      </div>
      <div className="col-md-7">
        <div
          id="carouselExampleCaptions"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            {curouselData?.map((item, index) => (
              <button
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
                aria-current={index === 0 ? "true" : undefined}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>
          <div
            className="carousel-inner"
            style={{ maxWidth: "600px", margin: "auto" }}
          >
            {curouselData?.map((item, index) => (
              <div
                className={`carousel-item ${index === 0 ? "active" : ""}`}
                key={index}
              >
                <div className="imageCard">
                  <img src={item.imgPath} className="rounded w-100" alt="..." />
                </div>
                <div className=" d-none d-md-block colorTheme1 mt-3">
                  <h5 className="text-center fw-bold">{item.text}</h5>
                  <p className="text-center">{item.subText}</p>
                </div>
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      <div className="col-md-5">
        <div className="loginDiv position-relative py-5">
          <div className="logoCircleDiv">
            <img
              src={localImages?.logoCircle}
              className="img-fluid loginCirclelogo "
              alt="logo"
            />
          </div>
          <h3 className="text-center fw-bold colorTheme1">
            Welcome to Two Brothers
          </h3>
          {/* <p className="text-center">Let's Get Started</p> */}
          <p className="text-center mb-2">To get started,</p>
          <p className="text-center">
            Please verify yourself by entering your credentials
          </p>

          <div className="mobileField mt-5 px-2">
            <form onSubmit={handleSubmit} id="loginForm">
              <div className="mb-3">
                <label className="mb-2 fw-bold">User Name</label>
                <InputField
                  placeholder="Enter Username"
                  value={userName}
                  setInputText={(value: string) => setUserName(value)}
                />
              </div>
              <div>
                <label className="mb-2 fw-bold">Password</label>
                <InputField
                  placeholder="Enter Password"
                  value={password}
                  setInputText={(value: string) => setPassword(value)}
                  type="password"
                />
              </div>
              <div className="mt-5 text-center bgwhite col-md-10 col-lg-12">
                <Submitbtn
                  name="Login"
                  disabled={false}
                // onPress={onPressLogin}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
